var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.38C12.62 5.38 13.22 5.13 13.66 4.69C14.1 4.25 14.35 3.64002 14.35 3.02002H16.22C17.09 3.02002 17.92 3.36999 18.54 3.98999C19.16 4.60999 19.5 5.45002 19.51 6.33002V17.7C19.51 18.58 19.16 19.42 18.54 20.04C17.92 20.66 17.09 21.01 16.22 21.01H14.35C14.31 20.41 14.05 19.84 13.61 19.43C13.17 19.02 12.6 18.79 12 18.79C11.4 18.79 10.83 19.02 10.39 19.43C9.95001 19.84 9.68999 20.41 9.64999 21.01H7.78C6.91 21.01 6.07999 20.66 5.45999 20.04C4.83999 19.42 4.49999 18.58 4.48999 17.7L4.48999 6.32001C4.48999 5.44001 4.83999 4.59998 5.45999 3.97998C6.07999 3.35998 6.91 3.01001 7.78 3.01001H9.64999C9.64999 3.64001 9.9 4.24 10.34 4.69C10.78 5.14 11.38 5.39001 12 5.39001V5.38Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65991 13.95H14.3399",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.f5ead927867ead1ef12cf6705dfe1560.svg";
export { ForwardRef as ReactComponent };